import DrSaltzburgImage from "../assets/dr-saltzburg.png";

export function getProviderImage(provider, fallback) {
  const displayName = String(provider?.display_name || "");

  if (/saltzburg/i.test(displayName)) {
    return DrSaltzburgImage;
  }

  return provider?.image || fallback;
}
